import { Component, Input } from "@angular/core";
import { ErrorComponentBase } from "../error.decorator";
import { IMenu } from "app/types/menu";

export interface Error502PageComponent extends ErrorComponentBase { }
@Component({
    selector: "error-502-page-component",
    templateUrl: "../error.view.html",
    standalone: false
})
@ErrorComponentBase
export class Error502PageComponent {

  @Input() error: { [key: string]: any };
  @Input() home: IMenu = null;
  @Input() sections: IMenu[] = [];

  code: string = "502";
  subTitle: string = 'Bad Gateway';
  lead: string = `This page is taking too long to respond. We could not complete your request. Please try again later.`

}
